export default {
  loop: 0,
  one: 1,
  random: 2
}
